import React from 'react'

import { selectStacks } from 'app-redux/deck/selectors'
import { useAppSelector } from 'app-redux/hooks'

import StackHeader from 'components/deckPage/DeckContainerV2/StackHeader'
import SpreadsheetCard from 'components/card/deckCards/spreadsheetCard'
import StackWrapper from 'components/deckPage/dragAndDrop/StackWrapper'

import { useCategoryIsCollapsed } from 'hooks/collapsibleCategories'

import styles from './table.module.scss'
import cardStyles from 'components/card/deckCards/spreadsheetCard.module.scss' // importing this so our card column headers match the exact width of our columns
import { StackType } from 'types/deck'

const TableLayout = () => {
  const { mainDeck, sideDeck } = useAppSelector(selectStacks)

  const deck = [...mainDeck, ...sideDeck]

  return (
    <div className={styles.container} id="deck-table-view-container">
      <div className={styles.table}>
        <div className={`${styles.row} ${styles.columnHeaders} ${cardStyles.card}`}>
          <div className={cardStyles.dragHandle} />
          <div className={cardStyles.quantity} />
          <div className={`${cardStyles.cardName} ${styles.cardNameOverride}`}>Card name</div>
          <div className={cardStyles.modifier}>Finish</div>
          <div className={cardStyles.manaCost}>Mana cost</div>
          <div className={cardStyles.shoppingUrl}>Price One</div>
          <div className={cardStyles.shoppingUrl}>Price Two</div>
          <div className={cardStyles.collectionStatus}>Collection status</div>
          <div className={cardStyles.pinnedStatus}>Pinned status</div>
          <div className={cardStyles.colorTag}>Color Tag</div>
          <div className={cardStyles.setSymbol}>Rarity</div>
          <div className={cardStyles.setName}>Set name</div>
          <div className={cardStyles.categories}>Categories</div>
          <div className={cardStyles.companion}>Companion</div>
          <div className={styles.dropdownSpacer} />
        </div>

        {deck.map((stack, index) => (
          <Table stack={stack} key={`${stack.name}-${index}`} />
        ))}
      </div>
    </div>
  )
}

type TableProps = {
  stack: StackType
}
const Table = ({ stack }: TableProps) => {
  const isCollapsed = useCategoryIsCollapsed(stack.name)

  return (
    <StackWrapper name={stack.name} className={`${styles.stackWrapper} ${isCollapsed ? styles.collapsed : ''} `}>
      <StackHeader
        className={styles.stackHeader}
        name={stack.name}
        quantity={stack.quantity}
        mdfcQuantity={stack.mdfcQuantity}
        price={stack.price}
        cardIds={stack.cardIds}
        includeInDeck={stack.includedInDeck}
        includeInPrice={stack.includedInPrice}
        isPremier={stack.isPremier}
      />

      {!isCollapsed &&
        stack.cardIds.map(cardId => (
          <div className={styles.row} key={cardId}>
            <SpreadsheetCard cardId={cardId} stackName={stack.name} />
          </div>
        ))}
    </StackWrapper>
  )
}

export default TableLayout
